module.exports = __webpack_public_path__ + "img/4.1f1e0390.jpg";